import { render } from "./DFabs.vue?vue&type=template&id=6d36ca47&scoped=true"
import script from "./DFabs.vue?vue&type=script&lang=js"
export * from "./DFabs.vue?vue&type=script&lang=js"

import "./DFabs.vue?vue&type=style&index=0&id=6d36ca47&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d36ca47"]])

export default __exports__